var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"hide-details":"","label":"Obtener items que no tienen predicciones para la clasificación"},model:{value:(_vm.withoutPredictions),callback:function ($$v) {_vm.withoutPredictions=$$v},expression:"withoutPredictions"}})}
var staticRenderFns = []

export { render, staticRenderFns }